import React, { ReactNode } from "react";

import "src/styles/global.css";
import "src/styles/variables.css";
import { QueryProvider } from "src/fetcher/QueryProvider";
import { IntlProvider } from "src/i18n/IntlProvider";
import { AffiliateProvider } from "./Affilate";
import { HelmetProvider } from "react-helmet-async";

type Props = {
  children: ReactNode;
};

export const Provider: React.FC<Props> = ({ children }) => (
  <QueryProvider>
    <AffiliateProvider>
      <HelmetProvider>
        <IntlProvider>{children}</IntlProvider>
      </HelmetProvider>
    </AffiliateProvider>
  </QueryProvider>
);
